module.exports = __webpack_public_path__ + "img/facebook-blue.77cd230e.svg";